import { render, staticRenderFns } from "./3D-View.vue?vue&type=template&id=fbadc968&scoped=true"
import script from "./3D-View.vue?vue&type=script&lang=js"
export * from "./3D-View.vue?vue&type=script&lang=js"
import style0 from "./3D-View.vue?vue&type=style&index=0&id=fbadc968&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbadc968",
  null
  
)

export default component.exports